const isSafeUrl = (url: string): string | boolean => {
	try {
		const parsedUrl = new URL(url, window.location.origin);
		if (parsedUrl.protocol === 'http:' || parsedUrl.protocol === 'https:') {
			return parsedUrl.href;
		}
		console.warn('Blocked unsafe redirect:', url);
		return false;
	} catch (error) {
		console.error('Invalid URL:', url, error);
		return false;
	}
};

const safeRedirect = (url: string) => {
	const safeUrl = isSafeUrl(url);
	if (safeUrl) {
		window.location.href = safeUrl as string;
	}
};

export { safeRedirect };
